(function () {
  "use strict";

  var ENDPOINT = "https://chat.descolauniformes.com/bot/reposicao/inscrever";

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest("[data-reposicao-toggle]");
    if (!toggle) return;
    var wrapper = toggle.closest("[data-reposicao-avise]");
    var popup = wrapper.querySelector("[data-reposicao-popup]");
    popup.hidden = !popup.hidden;
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-reposicao-form]");
    if (!form) return;
    event.preventDefault();

    var wrapper = form.closest("[data-reposicao-avise]");
    var variantId = wrapper.dataset.variantId;
    var nomeInput = form.querySelector('input[name="nome"]');
    var nome = nomeInput ? nomeInput.value.trim() : "";
    var telefoneInput = form.querySelector('input[name="telefone"]');
    var telefoneDigitos = telefoneInput.value.replace(/\D/g, "");
    var msg = wrapper.querySelector("[data-reposicao-msg]");
    var button = form.querySelector('button[type="submit"]');

    if (!telefoneDigitos) return;

    button.disabled = true;
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // NÃO prefixa "55" aqui na cega — se a cliente colar um número que já
      // vem com o DDI (ex: copiado do Chatwoot, "+5591987455742"), prefixar
      // de novo duplicava o "55" e gerava um telefone inválido (achado ao
      // vivo, 2026-08-20, apontado pelo Guilherme testando esse caso). O
      // backend (normalizarTelefoneBr, reposicao.js) já lida certinho com
      // número com ou sem DDI, com ou sem o "9" — manda só os dígitos como
      // vieram e deixa ele decidir.
      body: JSON.stringify({
        variantId: variantId,
        telefone: telefoneDigitos,
        nome: nome || undefined,
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        msg.hidden = false;
        if (result.ok) {
          msg.textContent = "Prontinho! Vamos te avisar por WhatsApp assim que chegar 😊";
          form.hidden = true;
        } else {
          msg.textContent = (result.data && result.data.erro) || "Não deu certo, tenta de novo em instantes.";
          button.disabled = false;
        }
      })
      .catch(function () {
        msg.hidden = false;
        msg.textContent = "Não deu certo, tenta de novo em instantes.";
        button.disabled = false;
      });
  });

  // O tema (Shopify Horizon) só re-renderiza via fetch+morph um conjunto
  // fixo de elementos quando a cliente troca tamanho/cor (preço, botão de
  // comprar, disponibilidade) — esse bloco NÃO faz parte desse conjunto,
  // então sem isso ele ficava preso no estado da variante carregada na
  // primeira vez, só corrigindo depois de um F5 (achado ao vivo,
  // 2026-08-20, apontado pelo Guilherme testando troca de tamanho/cor sem
  // recarregar a página). Solução: cada bloco carrega os dados de TODAS as
  // variantes do produto (id/disponibilidade/opções) direto do Liquid e
  // ouve os mesmos eventos "change" dos seletores nativos de tamanho/cor
  // pra recalcular sozinho, sem depender do sistema de re-render do tema.
  function inicializarBlocos() {
    var blocos = document.querySelectorAll("[data-reposicao-avise]");
    for (var i = 0; i < blocos.length; i++) {
      configurarReatividade(blocos[i]);
    }
  }

  function configurarReatividade(wrapper) {
    var dadosScript = wrapper.querySelector("[data-reposicao-dados]");
    if (!dadosScript) return;
    var dados;
    try {
      dados = JSON.parse(dadosScript.textContent);
    } catch (e) {
      return;
    }

    function variantePorOpcoesAtuais() {
      var valores = dados.optionNames.map(function (nome) {
        var el = document.querySelector(
          'variant-picker select[name="options[' + nome + ']"], ' +
            'variant-picker input[name="options[' + nome + ']"]:checked'
        );
        return el ? el.value : null;
      });
      return dados.variantes.find(function (v) {
        return (
          v.options.length === valores.length &&
          v.options.every(function (val, idx) {
            return val === valores[idx];
          })
        );
      });
    }

    function atualizar() {
      var variante = variantePorOpcoesAtuais();
      if (!variante) return;
      if (variante.available === false) {
        // Reseta o formulário sempre que a variante muda de verdade (ex:
        // cadastrou no tamanho 10, trocou pro 12 sem recarregar a página) —
        // sem isso o botão ficava com cara de "já usado" (form escondido,
        // mensagem de "Prontinho!" ainda visível) pro tamanho novo, mesmo
        // sendo um cadastro totalmente diferente. Só reseta quando a
        // variante realmente mudou, não em todo evento de "change" à toa
        // (achado ao vivo, 2026-08-27, pedido do Guilherme: precisava dar
        // F5 pra cadastrar um segundo tamanho da mesma peça).
        if (wrapper.dataset.variantId !== variante.id) {
          var form = wrapper.querySelector("[data-reposicao-form]");
          if (form) {
            form.hidden = false;
            form.reset();
            var button = form.querySelector('button[type="submit"]');
            if (button) button.disabled = false;
          }
          var msgEl = wrapper.querySelector("[data-reposicao-msg]");
          if (msgEl) {
            msgEl.hidden = true;
            msgEl.textContent = "";
          }
        }
        wrapper.hidden = false;
        wrapper.dataset.variantId = variante.id;
        // Texto visível da peça (nome + tamanho/cor) ficava travado no que
        // carregou na primeira vez, mesmo com o data-variant-id (o que
        // importa de verdade pro cadastro) já certo — achado ao vivo,
        // 2026-08-21, apontado pelo Guilherme: popup mostrando "— 4" com
        // tamanho 16 selecionado (cadastro em si saiu correto, só o texto
        // que ficou desatualizado).
        var pecaEl = wrapper.querySelector("[data-reposicao-peca]");
        if (pecaEl) {
          var opcoesTexto = variante.options.filter(Boolean).join(" / ");
          pecaEl.textContent = opcoesTexto && opcoesTexto !== "Default Title"
            ? dados.tituloProduto + " — " + opcoesTexto
            : dados.tituloProduto;
        }
      } else {
        wrapper.hidden = true;
        var popup = wrapper.querySelector("[data-reposicao-popup]");
        if (popup) popup.hidden = true;
      }
    }

    document.addEventListener("change", function (event) {
      if (event.target.closest("variant-picker")) atualizar();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", inicializarBlocos);
  } else {
    inicializarBlocos();
  }
})();
